import { cn } from '@heidi/utils';
import type { ReactNode } from 'react';

interface VoiceWindowOverlayShellProps {
  entered: boolean;
  minimizeLabel: string;
  onMinimize: () => void;
  children: ReactNode;
}

/** Scrim + centering frame around {@link VoiceWindow}'s card (overlay only). */
export function VoiceWindowOverlayShell({
  entered,
  minimizeLabel,
  onMinimize,
  children,
}: VoiceWindowOverlayShellProps) {
  return (
    <div
      className={cn(
        'fixed inset-0 z-[90] flex items-stretch justify-center',
        'p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] md:p-6',
        'transition-opacity duration-200 ease-out motion-reduce:transition-none',
        entered ? 'opacity-100' : 'opacity-0'
      )}
      data-testid="voice-workspace-overlay"
    >
      <button
        type="button"
        aria-label={minimizeLabel}
        onClick={onMinimize}
        className="absolute inset-0 cursor-default bg-overlay backdrop-blur-sm"
        data-testid="voice-workspace-scrim"
        tabIndex={-1}
      />
      {children}
    </div>
  );
}
